export const REMEDIATION_SERVICE_ID = 'RemediationService';
export const ALERT_ACTIONS = 'alertActions';
